var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"divide-y divide-primary-50",class:_vm.classes},_vm._l((8),function(item){return _c('li',{key:item,staticClass:"animate-pulse h-2 my-4 py-4"},[_c('div',{staticClass:"rounded bg-primary-50 h-2 w-1/4"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }